import { useListBackerConsumerWallet } from '@givebacks/api/backer';
import { Modal, Skeleton, Stack } from 'ui';
import { randomId } from 'ui/Hooks';

import { ConsumerWalletListCard } from '../../Account/components/ConsumerWalletCard/ConsumerWalletListCard';

const ConsumerExpiredWalletContent = () => {
  const { data: walletCards, isLoading } = useListBackerConsumerWallet({ expired: true });
  return (
    <Skeleton visible={isLoading}>
      <Stack gap={0}>
        {walletCards?.map((card) => <ConsumerWalletListCard walletCard={card} key={randomId()} />)}
      </Stack>
    </Skeleton>
  );
};

const ConsumerExpiredWalletModal = ({
  onClose,
  opened,
}: {
  onClose: () => void;
  opened: boolean;
}) => {
  return (
    <Modal opened={opened} onClose={onClose} title="View Expired">
      <ConsumerExpiredWalletContent />
    </Modal>
  );
};
export { ConsumerExpiredWalletModal };
